require('./brokerOneAlert.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');


const OneAlert = props => {
    const { myDate, stockName, summary } = props;

    return (
        <div className="one-alert">
            <div className="one-alert__date">
                <i className="one-alert__icon icon icon-bookmark"></i>
                <span className="label-date">{myDate}</span>
            </div>
            <div className="one-alert__stock-name">
                {stockName}
            </div>
            <p className="one-alert__summary">
                {summary}
            </p>
        </div>
    );
};

OneAlert.propTypes = {
    myDate: PropTypes.string,
    stockName: PropTypes.string,
    category: PropTypes.string,
    summary: PropTypes.string,
};

module.exports = OneAlert;
